import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service';
import { ConfigService } from 'src/app/services/config-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-grameenphone-docs',
  templateUrl: './grameenphone-docs.component.html',
  styleUrls: ['./grameenphone-docs.component.scss'],
})
export class GrameenphoneDocsComponent {
  successRes = `
  {
    "statusCode": 200,
    "message": "Successful",
    "data": [
        {
            "serviceId": "00000000",
            "title": "title of product",
            "validity": "validity",
            "durationInDay": 0,
            "price": 0.0,
            "isRenewal" : true
        },
        {
            "serviceId": "00000001",
            "title": "title of product",
            "validity": "validity",
            "durationInDay": 0,
            "price": 0.0,
            "isRenewal" : true
        }
    ]
}`;
  wrongServiceRes = `
{
    "statusCode": 400,
    "message": "Not found any product for …",
    "data": null
}`;

  reqBody = `
{
    "msisdn": "8800000000000",
    "serviceId": "00000",    
    "channel" : "Channel name",
    "paymentSuccessRedirectUrl": "example.url",
    "paymentFailedRedirectUrl": "example.url",
    "paymentDenyRedirectUrl": "example.url",
    "transactionId" : "Trx-001"
}
 `;
  reqSucRes = `
{
    "statusCode": 200,
    "message": "Success",
    "data": {
        "paymentUrl": "https://sg.dob.payment.io/v3/consent/redirect?token=48d181d0-63e1-4914-ba63-1c756590cef5&errorUrl=https%3A%2F%2Fapi.payment-app.info%2Fgrameenphone%2Fviews%2Ferror%3FserviceId%3D4001%26msisdn%3D8801795683781"
    }
}
 `;
  reqServerErrorRes = `
{
    "statusCode": 500,
    "message": "Something went wrong! Please try again.",
    "data": null
} 
 `;
  checkReqRes = `
 {
     "statusCode": 200,
     "message": "Successful",
     "data": {
         "msisdn": "8800000000000",
         "serviceId": "00000000",
         "nextRenewalDate": 1702467892
     }
 } 
 `;
  checkNotFoundRes = `
 {
     "statusCode": 200,
     "message": "Not found any subscription",
     "data": null
 }
 `;
  cancelReq = `
 {
     "statusCode": 200,
     "message": "Successful"
 }
 `;
  cancelRes = `
 {
     "statusCode": 200,
     "message": "Failed"
 }
 '`;
  vendor: string | null = null;
  productsByNameApi: string = '';
  createCheckoutSessionApi: string = '';
  checkSubscriptionByNameApi: string = '';
  cancelSubscriptionApi: string = '';
  domain: string = environment.apiUrl;

  constructor(
    private config: ConfigService,
    private route: ActivatedRoute,
    public authService: AuthService
  ) {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.config.getByMarchent(params['id']).subscribe((e) => {
          console.log(e);
          if (e && e.length > 0) {
            this.vendor = e[0].merchant;
            console.log(this.vendor);
            this.initializeApiRoute();
          }
        });
      }
    });
  }

  initializeApiRoute() {
    this.productsByNameApi = `${this.domain}/grameenphone/billing/products_by_name?name=${this.vendor}`;
    this.createCheckoutSessionApi = `${this.domain}/grameenphone/checkout/create-checkout-session/${this.vendor}`;
    this.checkSubscriptionByNameApi = `${this.domain}/grameenphone/billing/check_subscription_by_name?msisdn=8800000000000&name=${this.vendor}`;
    this.cancelSubscriptionApi = `${this.domain}/grameenphone/billing/cancel-subscription`;
  }
}
